import React, { Component } from 'react'
import { BrowserRouter as Router, Route, BrowserRouter, Switch } from 'react-router-dom';
//import Cards from './components/Cards/Cards.jsx';
//import Charts from './components/Charts/Charts.jsx';
//import CountryPicker from './components/CountryPicker/CountryPicker.jsx';

import { Cards, Charts, CountryPicker, Navbar, Backdrop, Sidedrawer, NigeriaCard, ContactPage, BodyInfo, Loader, Commentdrawer, Commentsection, Footer, Comment_sectiondrawer } from './components'
import styles from './App.module.css';
import { fetchData } from './api';
import corona from './images/corona.png'
import covidbg from './images/covidbg.jpg';
import { fetchNigeria } from './api';
import Aos from 'aos';


class App extends Component {
    constructor(props) {
        super(props);
        this.main = React.createRef();
    }

    handleScroll = (e) => {
        const main = this.main.current;
        window.scrollTo({
            top: main.offsetTop,
            left: 0,
            behavior: 'instant'
        });
    };

    componentDidMount() {
        Aos.init({
            duration: 2900
        })
    }

    drawerToggleClickHandler = () => {
        this.setState((prevState) => {
            return { sidedraweropen: !prevState.sidedraweropen }
        })
    }

    closedrawerState = () => {
        this.setState({ sidedraweropen: false })
    }

    closecommentState = () => {
        this.setState({ commentdraweropen: false })
    }

    commentToggleClickHandler = () => {
        this.setState((prevState) => {
            return { commentdraweropen: !prevState.commentdraweropen }
        })
    }

    state = {
        data: {},
        country: '',
        sidedraweropen: false,
        Nig: {},
        commentdraweropen: false
    }


    async componentDidMount() {
        const fetchedData = await fetchData();

        this.setState({ data: fetchedData })
    }

    async componentDidMount() {
        const fetchedNg = await fetchNigeria();

        this.setState({ Nig: fetchedNg })
    }

    handleCountryChange = async (country) => {
        //fetch the data
        const fetchedData = await fetchData(country);

        //set the state
        this.setState({ data: fetchedData, country: country });
    }

    // For the nigeria data
    async componentDidMount() {
        const fetchedNigeria = await fetchNigeria();

        this.setState({ Nig: fetchedNigeria })
    }

    render() {
        const { data, country, Nig } = this.state;
        let backdrops1;
        let backdrops2;

        if (this.state.sidedraweropen) {
            backdrops1 = <Backdrop backclose={this.closedrawerState} />
        }
        if (this.state.commentdraweropen) {
            backdrops2 = <Backdrop backclose={this.closecommentState} />
        }
        return (
            <Router>
                <div className={styles.container}>
                    <Route path="/" render={props => (
                        <React.Fragment>
                            <Navbar drawerClickHandler={this.drawerToggleClickHandler} handle={this.handleScroll} />
                            <Sidedrawer show={this.state.sidedraweropen} />
                            {backdrops1}
                            <img src={corona} className={styles.image} alt="COVID_19" />
                            <BodyInfo />
                            <Cards data={data} />
                            <CountryPicker handleCountryChange={this.handleCountryChange} />
                            <Charts ref={this.main} data={data} country={country} />
                            <NigeriaCard Nig={Nig} />
                            <ContactPage ref={this.main} />
                            <Commentsection ref={this.main} />
                            <Comment_sectiondrawer commenthandler={this.commentToggleClickHandler} />
                            <Commentdrawer show={this.state.commentdraweropen} />
                            {backdrops2}
                        </React.Fragment>
                    )} />
                </div>
                <div>
                    <Footer />
                </div>
            </Router>
        )
    }
}


export default App